import React, { useState, useEffect } from "react";
import DataTable from "../../Common/DataTable/DataTable";
import { mcbBeneficiary, mcbAddBeneficiaryList, mcbAddBeneficiary } from "../../api";
import CustomSpinner from "../../Common/Spinner";
import { MCBBeneficiaryColumns, MCBAddBeneficiaryColumns } from "../../utils/tableHeader";
import Pagination from "../../Common/Pagination/Pagination";
import DataLoader from "../../Common/DataLoader/DataLoader";
import Button from "../../Common/Button";
import { Offcanvas } from "react-bootstrap";
import CreateBeneficiary from "./CreateBeneficiary";
import styles from "./beneficiary.module.css"; 
import withFeatureActions from "../../withFeatureActions";

const Beneficiary = ({ userId, userStatus, featureAccess }) => {
  const { readAccess, writeAccess, modifyAccess } = featureAccess;
  const [dataLoading, setDataLoading] = useState(false);
  const [beneficiaryData, setBeneficiaryData] = useState([]);
  const [addBeneficiaryData, setAddBeneficiaryData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [showCreateBeneficiary, setShowCreateBeneficiary] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successTimeout, setSuccessTimeout] = useState(null);

  const fetchBeneficiaryDetails = async (page = 1) => {
    try {
      setDataLoading(true);
      const response = await mcbBeneficiary(userId, page, pageSize);

      if (response?.status === 200) {
        const beneficiaryList = response?.data?.data?.beneficiaries || [];
        const count = response?.data?.data?.count || 0;
        setBeneficiaryData(beneficiaryList);
        setTotalPages(Math.ceil(count / pageSize));
        setErrorMessage(null);
      } else {
        setErrorMessage(
          response?.data?.message || "Failed to fetch beneficiary details"
        );
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Something went wrong");
    } finally {
      setDataLoading(false);
    }
  };
    const fetchAddBeneficiaryDetails = async () => {
    try {
      setDataLoading(true);
      const response = await mcbAddBeneficiaryList();
      if (response?.status === 200) {
        const addBeneficiaryList = response?.data?.data || [];
        setAddBeneficiaryData(addBeneficiaryList);
        setErrorMessage(null);
      } else {
        setErrorMessage(
          response?.data?.message || "Failed to fetch beneficiary details"
        );
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Something went wrong");
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchBeneficiaryDetails(currentPage);
  }, [userId, currentPage]);
   useEffect(() => {
    fetchAddBeneficiaryDetails();
  }, []);

    const handleShowAddBeneficiary = () => {
    setShowCreateBeneficiary(true);
  };

  const handleCreateBeneficiary = (newBeneficiary) => {
    setBeneficiaryData((prevBeneficiaries) => [newBeneficiary, ...prevBeneficiaries]);
    setShowCreateBeneficiary(false);
   setSuccessMessage("Beneficiary created successfully!");
  const timeout = setTimeout(() => {
    setSuccessMessage("");
    fetchBeneficiaryDetails(currentPage);
    setSuccessTimeout(null);
  }, 3000);
  setSuccessTimeout(timeout);
}
  
   const handleSelectionChange = (beneficiary, isChecked) => {
      if (isChecked) {
        setSelectedBeneficiaries(prev => [...prev, beneficiary]);
      } else {
        setSelectedBeneficiaries(prev => 
          prev.filter(item => item.accountNo !== beneficiary.accountNo)
        );
      }
    };
    
const handleSubmitSelected = async () => {
  if (selectedBeneficiaries.length === 0) {
    setErrorMessage("Please select beneficiary account");
    setTimeout(() => {
      setErrorMessage(null);
    }, 5000);
    return;
  }

  setIsSubmitting(true);

  try {
    const beneficiary = selectedBeneficiaries[0];

    const beneficiaryData = {
      ...beneficiary,
      userId: userId,
    };

    const response = await mcbAddBeneficiary(beneficiaryData);

    if (response.status === 200) {
      if (successTimeout) {
        clearTimeout(successTimeout);
      }
      setSuccessMessage("Beneficiary added successfully!");
      setSelectedBeneficiaries([]);
      const timeout = setTimeout(() => {
        setSuccessMessage("");
        fetchBeneficiaryDetails(currentPage);
        fetchAddBeneficiaryDetails();
        setSuccessTimeout(null);
      }, 3000);
      setSuccessTimeout(timeout);
    } else {
      setErrorMessage(response?.data?.message || "Failed to add beneficiary.");
    }

    setTimeout(() => {
      setErrorMessage(null);
    }, 5000);

  } catch (error) {
    setErrorMessage(error?.response?.data?.message || "Error adding beneficiary.");
    setTimeout(() => {
      setErrorMessage(null);
    }, 5000);
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <DataLoader isLoading={dataLoading} >
      <div style={{ marginTop: "30px"}}>
        <DataTable
          columns={MCBBeneficiaryColumns}
          list={beneficiaryData}
          rowClick={false}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pagination={true}
          title="Beneficiary List"
          titleButton={writeAccess && userStatus === "APPROVED" && ( <Button onClick={handleShowAddBeneficiary} title={"Add Beneficiary"} /> ) }
        />

          <Offcanvas 
            show={showCreateBeneficiary} 
            onHide={() => setShowCreateBeneficiary(false)}
            placement="end"
            className={styles.offcanvas}
            style={{ color: "white", backgroundColor: "#28282B", width: "650px" }}   
            >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title style={{ color: "white" }}>Add Beneficiary</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <CreateBeneficiary
                userId={userId}
                onSuccess={handleCreateBeneficiary}
                onCancel={() => setShowCreateBeneficiary(false)}
                />
            </Offcanvas.Body>
          </Offcanvas>
                </div>
        {writeAccess && userStatus === "APPROVED" && (
        <div style={{ marginTop: "30px" }}>
        <DataTable
          columns={MCBAddBeneficiaryColumns}
          list={addBeneficiaryData}
          rowClick={false}
          title="Available Beneficiary Account"
          enableCheckbox={true}
          selectedItems={selectedBeneficiaries}
          onSelectionChange={handleSelectionChange}
          submitButton={
             <Button
                onClick={handleSubmitSelected}
                title={"Add Selected Beneficiary"}
                loading={isSubmitting}
                disabled={isSubmitting}
            />
          }
          successMessage={successMessage}
          errorMessage={errorMessage} 
        />
      </div>
      )}
    </DataLoader>
  );
};

export default Beneficiary;
